const state = () => ({
    livelapsName: "LiveLaps Inc",
    windowWidth: window.innerWidth,
    languages: [
        { value: "en", label: "English" },
        { value: "es", label: "Español" },
        { value: "fr", label: "Français" }
    ]
});

const mutations = {
    setWindowWidth(state, value) {
        state.windowWidth = value;
    }
}

const getters = {
    windowWidth: (state) => state.windowWidth,
    getLanguages: (state) => state.languages
}

const actions = {
    async setWindowWidthAction(context) {  
        context.commit('setWindowWidth', window.innerWidth)
    }
}

export default {
    state, mutations, actions, getters
}